import { Component, OnInit, Input, Output, EventEmitter, HostListener, Injectable } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { OnChanges } from '@angular/core';
import { ToastService } from '../../shared/providers/toast.service';


@Component({
  selector: 'file-upload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css']

})
export class FileuploadComponent implements OnInit, OnChanges {

  errors: Array<string> = [];
  dragAreaClass: string = 'dragarea';
  @Input() fileExt: string = "JPEG,GIF,PNG,JPG";
  @Input() fileDocExt: string = "pdf,xlsx,doc,docx,jpeg,gif,png,xls,jpg,txt,dwg";
  @Input() fileDocLOIExt: string = "pdf, doc, docx";
  @Input() confidentialityAgreementTypes: string = '';
  @Input() maxFiles: number = 5;
  @Input() maxSize: number = 5; // 5MB
  @Output() selectedFilesListEmitter = new EventEmitter();
  @Output() selectedFilePathEmitter = new EventEmitter();
  @Input() clearFilescounter: number = 0;
  @Input() uploadType: string;
  @Input() extensionType: string;
  @Input() docType: string;
  @Input() fileTypes: string;
  @Input() extensionLOIType: string;
  @Input() showList: boolean = true;
  @Input() restrictionText: string;
  @Input() messageDisplayes: number = 0;


  selectFiles: string[] = [];

  constructor(private _toastService: ToastService) { }


  ngOnInit() {
    if (this.uploadType.trim().length <= 0) {
      this.uploadType = 'multiple';
    }
    if (this.extensionType == "document") { // if upload type is document then max file size is 30 MB
      this.maxSize = 30;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.clearFilescounter != 0) {
      this.selectFiles = [];
    }
    this.clearFilescounter = 0;
  }

  onFileChange(event: any) {
    this.addToFilesArray(event);
  }
  // File upload control Events -Start
  addToFilesArray(event: any) {
    let files = event.target.files;
    let IsValidFile = true;
    if (this.uploadType == 'single' && this.extensionType == 'document') {
      if (this.selectFiles.length > 0) {
        this.errors.push("Error : Only one file accepted at a time.");
        return false;
      }
      this.selectFiles = [];
    }

    // Validate file size and allowed extensions
    if (!this.IsvalidateFile(files)) {

      IsValidFile = false;
      this.selectedFilesListEmitter.emit(this.selectFiles);
    }
    if (IsValidFile) {
      if (this.uploadType == 'single' && this.extensionType != 'document') {
        this.selectFiles = [];
      }
      for (var i = 0; i < event.target.files.length; i++) {
        this.selectFiles.push(event.target.files[i]);
      }
      this.selectedFilesListEmitter.emit(this.selectFiles);
      if (this.uploadType == 'single') { // code to pass local path of selected image into parent page to show preview in parent page image control
        var reader = new FileReader();
        let path: any;
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function () {
          path = reader.result;
        }
        setTimeout(() => {
          this.selectedFilePathEmitter.emit(path);
        }, 100);
      }
    }
  }

  IsvalidateFile(File: any) {
    this.errors = []; // Clear error     
    if (File.length > 0 && (!this.isValidFiles(File))) {
      return false;
    }
    else {
      return true;
    }
  }

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }

  @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }

  @HostListener('dragend', ['$event']) onDragEnd(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }

  @HostListener('drop', ['$event']) onDrop(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
    event.stopPropagation();
    let IsValidFile = true;
    var files = event.dataTransfer.files;
    if (this.uploadType == 'single') {
      if (this.selectFiles.length > 0) {
        this.errors.push("Error : Only one file accepted at a time.");
        return false;
      }
    }
    if (!this.IsvalidateFile(files)) {
      IsValidFile = false;
    }
    if (IsValidFile) {
      for (var i = 0; i < event.dataTransfer.files.length; i++) {
        this.selectFiles.push(event.dataTransfer.files[i]);
      }
      this.selectedFilesListEmitter.emit(this.selectFiles);
    }
  }
  // File upload control Events -End


  removeImage(fileIndex: number, event: any) {
    event.preventDefault();
    var currentFilesize = 0;
    if (fileIndex > -1) {
      this.selectFiles.splice(fileIndex, 1);
    }

    if (this.uploadType == 'single') { // code to set defualt image in parent page image control
      this.selectedFilePathEmitter.emit('/../../../assets/img/default-profile-img.png');
    }
    else {
      this.selectedFilesListEmitter.emit(this.selectFiles);
    }
  }

  //uploaded File Validations - Start 

  private isValidFiles(files: any) {
    // Check Number of files       
    //if (files.length > this.maxFiles) {
    //  this.errors.push("Error : Maximum " + this.maxFiles + " file(s) at a time.");
    //  return;
    //}
    return this.isValidFileExtension(files);
  }

  private isValidFileExtension(files: any): boolean {
    var totalFilesize = 0;
    var extenstionType = this.extensionType;
    var extensionLOIType = this.extensionLOIType;
    var extensions;

    // Make array of file extensions
    if (extenstionType == "document" && extensionLOIType == "LOI") {
      extensions = (this.fileDocLOIExt.split(','))
        .map(function (x) { return x.toLocaleUpperCase().trim() });
    }
    else if (extenstionType == "document") {
      if (this.confidentialityAgreementTypes != null && this.confidentialityAgreementTypes != '' && this.confidentialityAgreementTypes != undefined) {
        extensions = (this.confidentialityAgreementTypes.split(','))
          .map(function (x) { return x.toLocaleUpperCase().trim() });
      }
      else {
        extensions = (this.fileDocExt.split(','))
          .map(function (x) { return x.toLocaleUpperCase().trim() });
      }
    }

    else {

      extensions = (this.fileExt.split(','))
        .map(function (x) { return x.toLocaleUpperCase().trim() });
    }

    for (var i = 0; i < files.length; i++) {
      // Get file extension
      var ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
      // Check the extension exists
      var exists = extensions.indexOf(ext);
      let IsvalidSize = this.isValidFileSize(files[i]);
      let validationMessage = "";
      if (exists < 0) {
        validationMessage = "Error : Invalid file extension - " + files[i].name;
      }
      if (exists < 0 && extensionLOIType == 'LOI') {
        validationMessage = "Only pdf, doc, docx files accepted";
      }
      //if (!IsvalidSize) {
      //    validationMessage = validationMessage.trim().length > 0 ? validationMessage + " &" : validationMessage;
      //    validationMessage += " File size should be  < " + this.maxSize + " MB";
      //}

      if (validationMessage.trim().length > 0) {
        this.errors.push(validationMessage);
      }

    }
    return this.errors.length > 0 ? false : true;
  }

  private isValidFileSize(file: any) {
    var fileSizeinMB = file.size / (1024 * 1000);
    var size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
    if (size > this.maxSize) {
      return false;
    }
    else {
      return true;
    }
    //this.errors.push("Error (File Size): " + file.name + ": exceed file size limit of " + this.maxSize + "MB ( " + size + "MB )");
  }

  //private CurrentFileSize(file: any) {
  //  var fileSizeinMB = file.size / (1024 * 1000);
  //  var size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
  //  return size;
  //}

}
